import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const location = useLocation();

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="/Moments Logo-44.png" 
                alt="Moments" 
                className="h-16 w-auto"
              />
            </Link>
          </div>
          
          {/* Desktop menu - site map */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-8">
              <Link 
                to="/about" 
                className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 text-sm font-medium rounded-lg transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
          
          {/* Mobile menu */}
          <div className="md:hidden flex items-center space-x-4">
            <Link 
              to="/about" 
              className="text-gray-700 hover:text-primary-600 px-2 py-1 text-sm font-medium transition-colors"
            >
              About Us
            </Link>
            <Link 
              to="/contact" 
              className="bg-primary-500 hover:bg-primary-600 text-white px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
